import { render } from 'preact';
import { App } from './App';
import { FournisseurSession } from './session/ContexteSession';
import './styles/polices.css';
import './styles/theme.css';
// Transitoire — les jetons `--sygap-*` de l'ancien système restent servis tant
// que tous les écrans ne sont pas repris sur Tailwind. À retirer avec la
// dernière feuille `.css` de page. `base.css`, lui, est déjà parti : il imposait
// `border-radius: 0` sur `*` et aurait annulé tout rayon du nouveau thème.
import './styles/jetons.css';
import './styles/motifs.css';

/**
 * Amorçage de l'interface.
 *
 * Le code des composants s'écrit en React et Preact l'exécute (`preact/compat`) ;
 * le montage, lui, passe par l'API de Preact plutôt que par un `createRoot`
 * mimé. C'est le seul endroit où la différence est visible, et la nommer vaut
 * mieux que la déguiser.
 *
 * `StrictMode` n'est pas monté : c'est une aide au développement propre à React,
 * que `preact/compat` ne rend qu'en simple passe-plat. La garder donnerait
 * l'illusion d'un contrôle qui n'a pas lieu.
 */
const racine = document.getElementById('racine');
if (racine === null) {
  throw new Error("L'élément racine #racine est absent de index.html.");
}

render(
  <FournisseurSession>
    <App />
  </FournisseurSession>,
  racine,
);
